import React from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import { Translation } from 'react-i18next'
import { WatchField, useWatch } from '../../form'
import SumField from './sumField.component'
import InvoiceInputRow from './invoiceInputRow.component'
import { invoiceRowDefaultValues } from './invoiceForm.component'
import classNames from 'classnames'
import GroupInvoiceRow from './groupInvoiceRow.component'
import { Field } from '../../form'
import CustomIconTooltip from '../../utils/CustomIconTooltip'
import { getInvoiceUserEmail } from '../../actions'

const styles = (theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },
  table: {
    minWidth: 700
  },
  tablecell: {
    fontWeight: 'bold',
    fontSize: '13px',
    color: 'black',
    paddingRight: '10px !important',
    paddingLeft: '10px !important',
    paddingTop: '10px !important',
    paddingBottom: '10px !important'
  },
  tablecell1: {
    fontWeight: 'normal',
    fontSize: '13px',
    color: '#9e9e9e',
    //paddingRight: '3px',
    width: '1px',
    display: 'none'
  },
  button: {
    margin: theme.spacing(1),
    marginTop: '0px'
  },
  disabledTextField: {
    marginTop: theme.spacing(1),
    fontSize: '13px',
    color: 'black',
    marginLeft: '-8px',
    fontWeight: 'bold'
  },
  disabledTextField1: {
    marginTop: theme.spacing(2),
    fontSize: '13px',
    color: 'black',
    marginLeft: '-8px',
    fontWeight: 'bold'
  },
  textField: {
    marginTop: theme.spacing(4),
    border: '1px solid gray'
  },
  resize: {
    fontSize: '14px'
  },
  switch: {
    position: 'relative',
    marginLeft: '10px',
    fontSize: '15px',
    fontWeight: 'bold',
    color: '#808080'
  },
  groupInv: {
    marginTop: '60px'
  },
  groupInvoiceInformation: {
    padding: 10
  },
  groupInvExpand: {
    display: 'flex',
    [theme.breakpoints.down('350')]: {
      display: 'block'
    }
  },
  groupInvoiceItem: {
    paddingRight: '30px',
    [theme.breakpoints.down('350')]: {
      paddingRight: '0px'
    }
  },
  buttonContainer: {
    position: 'relative',
    marginTop: '20px',
    textAlign: 'right'
  },
  groupInvoiceAmountLabel: {
    color: 'black',
    fontSize: '13px',
    fontWeight: 'bold',
    marginRight: '10px',
    marginTop: '23px',
    whiteSpace: 'nowrap'
  },
  groupInvoiceAmountContainer: {
    display: 'flex'
  }
})

const InvoiceInputTable = ({
  classes,
  fields,
  addRow,
  removeRow,
  setValue,
  control,
  clearErrors,
  getValues,
  shouldDisableVat0,
  groupInvoiceFields,
  addGroupInvoiceRow,
  removeGroupInvoiceRow,
  groupEmailCount,
  totalInvoiceInputSum,
  groupTotalAmount,
  isExpenseAllowanceRow,
  calculateGroupRowAmount,
  isQuickPay,
  resetGroupInvoice,
  isGroupAmountEmpty
}) => {
  const dispatch = useDispatch()
  const watchFields = getWatchFields(
    fields,
    'sum_tax_free',
    'sum_with_vat',
    'vat_percent'
  )
  const watchGroupFields = getWatchGroupFields(
    groupInvoiceFields,
    'groupAmount'
  )
  const hasAllowanceRow = watchFields.hasAllowanceRow

  const vats = useWatch({
    fields: watchFields.vat,
    control: control,
    disabled: !hasAllowanceRow
  })

  const groupInvoiceCheck = useWatch({
    fields: 'groupInvoice',
    control: control
  })

  const addCostCheck = useWatch({
    fields: 'addCost',
    control: control
  })
  const addAllowanceCheck = useWatch({
    fields: 'addAllowance',
    control: control
  })
  const addWorkshiftJournalCheck = useWatch({
    fields: 'addWorkshiftJournal',
    control: control
  })

  const vat_selection = useWatch({
    fields: 'vat_selection',
    control: control
  })

  const _addRow = () => {
    const values = { ...invoiceRowDefaultValues }
    if (vat_selection.vat_selection === 'building_service') {
      values.vat_percent = 0
    }
    values.vat_percent = vat_selection.vat_selection
    addRow(values)
    clearErrors('rows')
  }

  const _removeRow = (index) => {
    removeRow(index)
    clearErrors('rows')
  }

  const handleCheckGroupInvoice = (e) => {
    const isChecked = e.target.checked

    if (isChecked) {
      dispatch(getInvoiceUserEmail(0))
      calculateGroupRowAmount()
    } else {
      resetGroupInvoice()
    }
  }

  return (
    <Translation>
      {(t) => (
        <div className="panel-body pd-0">
          <div className={classes.root}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.tablecell}>
                    {t('invoice.table')}
                  </TableCell>
                  <TableCell className={classes.tablecell1}>
                    {t('invoice.table12')}
                  </TableCell>
                  <TableCell className={classes.tablecell1}>
                    {t('invoice.table13')}
                  </TableCell>
                  <TableCell className={classes.tablecell}>
                    {t('invoice.table2')}
                  </TableCell>
                  <TableCell className={classes.tablecell}>
                    {t('invoice.table3')}
                  </TableCell>
                  <TableCell className={classes.tablecell}>
                    {t('invoice.table4')}
                  </TableCell>
                  <TableCell className={classes.tablecell}>
                    {t('invoice.table5')}
                  </TableCell>
                  <TableCell className={classes.tablecell}>
                    {t('invoice.table6')}
                  </TableCell>
                  <TableCell className={classes.tablecell}>
                    {t('invoice.table7')}
                  </TableCell>
                  <TableCell className={classes.tablecell}>
                    {t('invoice.table8')}{' '}
                  </TableCell>
                  <TableCell className={classes.tablecell}>
                    {t('invoice.table10')}
                  </TableCell>
                  <TableCell className={classes.tablecell}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <GenerateInputRows
                  fields={fields}
                  remove={_removeRow}
                  setValue={setValue}
                  getValues={getValues}
                  control={control}
                  maxVat={getMaxVat(
                    Object.values(vats),
                    hasAllowanceRow,
                    vat_selection.vat_selection === 'building_service'
                      ? true
                      : false
                  )}
                  shouldDisableVat0={shouldDisableVat0}
                  vat_selection={vat_selection.vat_selection}
                />
                <TableRow>
                  <TableCell
                    className={classes.tablecell}
                    colSpan={7}
                    style={{ borderBottom: '0px' }}
                  />
                  <TableCell
                    className={classes.tablecell}
                    align="left"
                    style={{ borderBottom: '0px' }}
                  >
                    <WatchField fields={watchFields.sum} control={control}>
                      {(fields) => (
                        <SumField
                          name="sum"
                          label={t('invoice.totalTaxFree')}
                          className={classes.disabledTextField}
                          control={control}
                          disabled={true}
                          disableUnderline
                          watchValue={calculateSum(fields)}
                          setValue={setValue}
                          labelStyle={{
                            color: 'black',
                            fontSize: '13px',
                            fontWeight: 'bold',
                            lineHeight: '1.2em',
                            textAlign: 'left',
                            display: 'block',
                            marginTop: '0px'
                          }}
                        />
                      )}
                    </WatchField>
                  </TableCell>
                  <TableCell
                    className={classes.tablecell}
                    align="left"
                    style={{ borderBottom: '0px' }}
                  >
                    <WatchField fields={watchFields.totalSum} control={control}>
                      {(fields) => (
                        <SumField
                          name="total_sum"
                          label={t('invoice.totalWithTax')}
                          className={classes.disabledTextField}
                          control={control}
                          disabled={true}
                          disableUnderline
                          watchValue={calculateSum(fields)}
                          setValue={setValue}
                          labelStyle={{
                            color: 'black',
                            fontSize: '13px',
                            fontWeight: 'bold',
                            marginTop: '0px'
                          }}
                        />
                      )}
                    </WatchField>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
          <div
            className="dashboard-invoice-add pull-right"
            style={{ marginTop: '10px' }}
          >
            <Button
              variant="contained"
              className={classes.button}
              onClick={_addRow}
            >
              {t('invoice.button6')}
            </Button>
          </div>
          {/*KAS-459 Group invoice*/}
          <div
            className={classNames(classes.groupInv, classes.resize)}
            style={{ display: 'block', clear: 'both' }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                <Field
                  name="groupInvoice"
                  label={t('groupInv.title')}
                  inputType="switch"
                  control={control}
                  className={classes.switch}
                  onChange={(e) => handleCheckGroupInvoice(e)}
                  disabled={
                    isQuickPay ||
                    isExpenseAllowanceRow ||
                    addCostCheck.addCost ||
                    addAllowanceCheck.addAllowance ||
                    addWorkshiftJournalCheck.addWorkshiftJournal
                      ? true
                      : false
                  }
                />
                <div style={{ marginTop: '4px' }}>
                  <CustomIconTooltip
                    info={t('groupInv.info', { returnObjects: true })}
                  />
                </div>
              </div>
            </div>
            {!isExpenseAllowanceRow && groupInvoiceCheck.groupInvoice ? (
              <div
                style={{
                  padding: '8px',
                  overflowX: 'auto',
                  marginTop: '0px'
                }}
              >
                <GenerateGroupInvoiceRows
                  groupInvoiceFields={groupInvoiceFields}
                  remove={removeGroupInvoiceRow}
                  setValue={setValue}
                  getValues={getValues}
                  control={control}
                  t={t}
                />
                <Grid container style={{ width: 800 }}>
                  <Grid item sm={5} />
                  <Grid item sm={7} style={{ paddingLeft: '20px' }}>
                    <WatchField
                      fields={watchGroupFields.groupAmount}
                      control={control}
                    >
                      {(fields) => (
                        <div
                          className={classes.groupInvoiceAmountContainer}
                          style={{
                            marginBottom: '8px'
                          }}
                        >
                          <label
                            for="groupTotalAmount"
                            className={classes.groupInvoiceAmountLabel}
                          >
                            {t('groupInv.label5')}
                          </label>
                          <SumField
                            name="groupTotalAmount"
                            className={classes.disabledTextField1}
                            control={control}
                            disabled={true}
                            helperTextStyle={{
                              marginTop: '0px',
                              height: '0px'
                            }}
                            disableUnderline
                            watchValue={calculateSum(fields)}
                            setValue={setValue}
                          />
                        </div>
                      )}
                    </WatchField>
                    <WatchField
                      fields={['groupTotalAmount', 'total_sum']}
                      control={control}
                    >
                      {(fields) => (
                        <div className={classes.groupInvoiceAmountContainer}>
                          <label
                            for="groupRemainAmount"
                            className={classes.groupInvoiceAmountLabel}
                          >
                            {t('groupInv.label6')}
                          </label>
                          <SumField
                            name="groupRemainAmount"
                            className={classes.disabledTextField1}
                            control={control}
                            disabled={true}
                            disableUnderline
                            watchValue={calculateRemain(
                              fields.groupTotalAmount,
                              fields.total_sum
                            )}
                            setValue={setValue}
                          />
                        </div>
                      )}
                    </WatchField>
                  </Grid>
                </Grid>
                <div className={classes.buttonContainer}>
                  <Button
                    variant="outlined"
                    className={classes.button}
                    onClick={addGroupInvoiceRow}
                    disabled={
                      groupEmailCount >= 5 ||
                      groupTotalAmount >= totalInvoiceInputSum
                    }
                  >
                    {t('groupInv.btn')}
                  </Button>
                  <Button
                    variant="contained"
                    className={classes.button}
                    onClick={calculateGroupRowAmount}
                    disabled={isGroupAmountEmpty}
                  >
                    {t('groupInv.calculateBtn')}
                  </Button>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      )}
    </Translation>
  )
}

export const GenerateInputRows = ({ fields, shouldDisableVat0, ...rest }) => {
  return fields.map((field, index) => (
    <InvoiceInputRow
      key={field.id}
      index={index}
      copy={true}
      autoFocusIndex={`${index}`}
      description={`rows.${index}.description`}
      invoice_expense_id={`rows.${index}.invoice_expense_id`}
      invoice_allowance_id={`rows.${index}.invoice_allowance_id`}
      startDate={`rows.${index}.start_date`}
      endDate={`rows.${index}.end_date`}
      quantity={`rows.${index}.quantity`}
      unit={`rows.${index}.unit`}
      quantityPrice={`rows.${index}.quantity_price`}
      vatPercent={`rows.${index}.vat_percent`}
      vatPercentDescription={`rows.${index}.vat_percent_description`}
      sumTaxFree={`rows.${index}.sum_tax_free`}
      sumWithVAT={`rows.${index}.sum_with_vat`}
      shouldDisableVat0={shouldDisableVat0}
      {...rest}
    />
  ))
}

export const GenerateGroupInvoiceRows = ({ groupInvoiceFields, ...rest }) => {
  return groupInvoiceFields.map((field, index) => (
    <GroupInvoiceRow
      key={field.id}
      index={index}
      groupEmail={`groupInvoiceRow.${index}.groupEmail`}
      groupAmount={`groupInvoiceRow.${index}.groupAmount`}
      {...rest}
    />
  ))
}

export const getWatchFields = (fields, sumField, totalField, vatField) => {
  const sum = []
  const totalSum = []
  const vat = []
  let hasAllowanceRow = false
  for (let i = 0; i < fields.length; i++) {
    sum.push(`rows.${i}.${sumField}`)
    totalSum.push(`rows.${i}.${totalField}`)
    if (
      fields[i].invoice_allowance_id === -1 &&
      fields[i].invoice_expense_id === -1
    ) {
      vat.push(`rows.${i}.${vatField}`)
    } else if (fields[i].invoice_allowance_id !== -1) {
      hasAllowanceRow = true
    }
  }
  return { sum, totalSum, vat, hasAllowanceRow }
}

export const getMaxVat = (vats, hasAllowanceRow, building_service) => {
  return vats.length !== 0
    ? Math.max.apply(
        null,
        vats.filter((el) => typeof el !== 'undefined')
      )
    : hasAllowanceRow && building_service
    ? 0
    : 25.5
}

export const getWatchGroupFields = (fields, groupAmountField) => {
  const groupAmount = []
  for (let i = 0; i < fields.length; i++) {
    groupAmount.push(`groupInvoiceRow.${i}.${groupAmountField}`)
  }
  return { groupAmount }
}

export const calculateSum = (fields) => {
  let sum = 0
  Object.values(fields).forEach((field) => {
    if (!isNaN(field) && field !== '') {
      sum += parseFloat(field)
    }
  })
  sum = Math.round((sum + Number.EPSILON) * 100) / 100
  return sum
}

export const calculateRemain = (currentSum, totalSum) => {
  let sum = 0
  if (!isNaN(currentSum) && currentSum !== '') {
    sum -= parseFloat(currentSum)
  }
  if (!isNaN(totalSum) && totalSum !== '') {
    sum += parseFloat(totalSum)
  }
  sum = Math.round((sum + Number.EPSILON) * 100) / 100
  return sum
}

InvoiceInputTable.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(InvoiceInputTable)
